export const MAP_ROUTES = [
  // {
  //   path: "basicMap",
  //   name: "basicMap",
  //   component: BasicMap
  // }
];
